import React, { useState, useRef } from 'react';
import api from '../lib/api';
import { Camera, User } from '@phosphor-icons/react';

export default function ProfilePhoto({ currentPhoto, onPhotoUpdate, size = 'md' }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);
  const sizeClass = size === 'sm' ? 'w-10 h-10' : size === 'lg' ? 'w-20 h-20' : 'w-14 h-14';
  const iconSize = size === 'sm' ? 16 : size === 'lg' ? 32 : 22;
  const API_BASE = process.env.REACT_APP_BACKEND_URL;

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64 = reader.result.split('base64,')[1];
        const { data } = await api.post('/profile/photo', { photo: base64 });
        if (onPhotoUpdate) onPhotoUpdate(data.url);
      };
      reader.readAsDataURL(file);
    } catch (err) {
      console.error('Photo upload failed:', err);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="relative group cursor-pointer" onClick={() => fileRef.current?.click()}>
      {currentPhoto ? (
        <img
          src={`${API_BASE}${currentPhoto}`}
          alt="Profile"
          className={`${sizeClass} rounded-full object-cover border-2 border-[#E5E5E5]`}
        />
      ) : (
        <div className={`${sizeClass} rounded-full bg-[#002FA7]/10 flex items-center justify-center border-2 border-[#E5E5E5]`}>
          <User size={iconSize} className="text-[#002FA7]" />
        </div>
      )}
      <div className="absolute inset-0 rounded-full bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
        <Camera size={iconSize - 4} className="text-white" />
      </div>
      {uploading && <div className="absolute inset-0 rounded-full bg-black/60 flex items-center justify-center"><div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /></div>}
      <input ref={fileRef} type="file" accept="image/*" onChange={handleFileSelect} className="hidden" />
    </div>
  );
}
